import React, { ReactChild, ReactChildren } from 'react';

import { Result as AResult, ResultProps } from 'antd';

export interface IResultParams extends ResultProps {
  children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[];
}

export const Result = ({ children, ...rest }: IResultParams) => <AResult {...rest}>{children}</AResult>;
